import createDataContext from './createDataContext';
import * as actions from './actions/vesselActions';
import { reducer, initialState } from './reducers/vesselReducer';

export const { Context: VesselContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
